export default {"src":"/_next/static/media/undraw_biking.8d0fdd8e.svg","height":653,"width":938,"blurWidth":0,"blurHeight":0};